import { render } from "./CreateInterviewStep2.vue?vue&type=template&id=96795b6e"
import script from "./CreateInterviewStep2.vue?vue&type=script&lang=js"
export * from "./CreateInterviewStep2.vue?vue&type=script&lang=js"

import "./CreateInterviewStep2.vue?vue&type=style&index=0&id=96795b6e&lang=css"

import exportComponent from "D:\\project2025\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__